import { dataRotateClockwiseSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconRotateClockwiseSolid = /*#__PURE__*/createIcon(dataRotateClockwiseSolid)
export default IconRotateClockwiseSolid
